import { useMemo, useState } from "react";
import { useParams, useLocation } from "react-router";
import { GeneralSettings, SettingsService } from "./Api";
import SettingsContext from "./SettingsContext";

const initState = {
    isLoading: true,
    settings: {
        textInputLimit: 0,
        emailInputLimit: 0,
        applicationPermittedExtensions: [],
        applicationPermittedMimeTypes: [],
        applicationFileNumberLimit: 0,
        applicationFileSizeLimit: 0,
        applicationPhoneNumberRegex: "",
        isUnicode: false,
        imagesUrl: "",
    } as GeneralSettings,
};

export const SettingsProvider = ({ children }) => {
    const { pathname } = useLocation();
    let { tenant = "", listName } = useParams();
    tenant = tenant === "" ? pathname.split('/')[1] : tenant; 
    const [state, setState] = useState(initState);

    const getSettings = async () => {
        const result = await SettingsService.getGeneralSettings(tenant);
        const newState = {
            isLoading: false,
            settings: result,
        };
        console.debug(newState);
        setState(newState);
    };
    
    const memo = useMemo(() => (state), [state]);

    if (memo.isLoading) getSettings();

    return (
        <SettingsContext.Provider value={state} >
            {children}
        </SettingsContext.Provider>
    );
}